import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updatePropertyMeta } from '../utils/metaUtils';

const CanonicalUpdater: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip updating canonical tag for login page
    if (location.pathname === '/login') {
      return;
    }

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    const canonicalUrl = window.location.origin + location.pathname;
    if (canonical.href !== canonicalUrl && !canonicalUrl.includes('login')) {
      canonical.href = canonicalUrl;
      updatePropertyMeta('og:url', canonicalUrl);
      updatePropertyMeta('twitter:url', canonicalUrl);
    }
  }, [location]);

  return null;
};

export default CanonicalUpdater;
